import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { getBundleDetails } from '../../../api-services';
import { UpdateSvg } from '../../../assets/images/Images';
import Country from '../../../components/Country';
import UpdateBundle from './UpdateBundle';
import BarLoader from 'react-bar-loader';

const isSearch = false;

const Bundles = ({
  setOpenModal,
  openModal,

  customerUniqueCode,
  setCustomerUniqueCode,
}) => {
  const [individualBundleData, setindividualBundleData] = useState({});
  const [showIndividualBundle, setshowIndividualBundle] = useState(false);

  const {
    data: bundleDetails,
    isLoading,
    isFetching,
  } = useQuery(
    'getBundleDetails',
    () => getBundleDetails({ uniquecode: customerUniqueCode }),
    {
      enabled: !!customerUniqueCode,
      select: (data) => data?.data?.data,
      cacheTime: 0,
    },
  );

  const handleClose = () => {
    setCustomerUniqueCode('');
    setOpenModal(false);
  };

  const updateBundleData = (data) => {
    setindividualBundleData(data);
    setshowIndividualBundle(true);
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={openModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Bundles</h5>
        </div>
        <div className="body-content-outer modal-body flex-column ">
          <div className="list_container w-100 ">
            {isSearch && (
              <div className="list_search">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="list_search_icon"
                  color="#c4d4d9"
                />
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search..."
                />
              </div>
            )}

            <div
              className={`list_header d-flex w-100 justify-content-between position-relative ${
                isSearch ? '' : 'border-radius-5'
              } bottom-left-radius-5 bottom-right-radius-5`}
            >
              {(isLoading || isFetching) && (
                <div className="custom-linear-loader-row">
                  <div className="custom-linear-loader" colSpan="13">
                    <BarLoader color="#ffc107" height="4px" />
                  </div>
                </div>
              )}
              <div className="list_header_group w-35"> Date</div>
              <div className="list_header_group w-35"> Country</div>
              <div className="list_header_group w-20"> Bundle</div>
              <div className="list_header_group w-15"> Type</div>
              <div className="list_header_group w-10"> Action</div>
            </div>
            <div className="list_body">
              {bundleDetails && bundleDetails.length > 0
                ? bundleDetails.map(
                    ({ created_at, bundle, bundle_type, alpha2code, id }) => (
                      <div className="list_row_group d-flex w-100 justify-content-between">
                        <div className="list_row w-35">{created_at}</div>
                        <div className="list_row w-35">
                          <Country isoCode={alpha2code} />
                        </div>
                        <div className="list_row w-20">{bundle}</div>
                        <div className="list_row w-15">{bundle_type}</div>
                        <div className="list_row w-10">
                          <OverlayTrigger
                            key="cta-update-bundle-btn"
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-top`}>
                                Update Bundle
                              </Tooltip>
                            }
                          >
                            <button
                              type="button"
                              className="btn btn-primary d-flex align-items-center justify-content-center  reload_icon"
                              onClick={() =>
                                updateBundleData({
                                  created_at,
                                  bundle,
                                  bundle_type,
                                  alpha2code,
                                  id,
                                })
                              }
                            >
                              <UpdateSvg />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                    ),
                  )
                : null}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>
        </div>
      </Modal>

      {showIndividualBundle && (
        <UpdateBundle
          individualBundleData={individualBundleData}
          setindividualBundleData={setindividualBundleData}
          showIndividualBundle={showIndividualBundle}
          setshowIndividualBundle={setshowIndividualBundle}
        />
      )}
    </>
  );
};

export default Bundles;
